import { render, staticRenderFns } from "./ExamSimulation.vue?vue&type=template&id=44457f98&scoped=true"
import script from "./ExamSimulation.vue?vue&type=script&lang=js"
export * from "./ExamSimulation.vue?vue&type=script&lang=js"
import style0 from "./ExamSimulation.vue?vue&type=style&index=0&id=44457f98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44457f98",
  null
  
)

export default component.exports